import { ColumnFilterItem } from 'antd/lib/table/interface'

export const buildTableFilterKeys = <T extends object>(
  objects: T[],
  key: string,
  presenter?: (value: string) => string,
): ColumnFilterItem[] => {
  const values = objects.map((currentObject) => currentObject[key])
  const uniqueValues = new Set(values)
  const filterValues = Array.from(uniqueValues)
    .filter((value) => !!value)
    .map((value) => ({
      text: presenter ? presenter(value) : value,
      value,
    }))

  return filterValues.sort(byText)
}

export const buildTableFilterInArrayKeys = <T extends object>(
  objects: T[],
  key: string,
  presenter?: (value: string) => string,
): ColumnFilterItem[] => {
  const values = objects.flatMap((currentObject) => currentObject[key])
  const uniqueValues = new Set(values)
  const filterValues = Array.from(uniqueValues)
    .filter((value) => !!value)
    .map((value) => ({
      text: presenter ? presenter(value) : value,
      value,
    }))

  return filterValues.sort(byText)
}

const byText = (firstColumn: ColumnFilterItem, secondColumn: ColumnFilterItem) =>
  String(firstColumn.text).localeCompare(String(secondColumn.text))
